<template>
  <DataList
    title="Завдання"
    resource="crm-tasks"
    :columns="columns"
    :get-items-fn="getTasks"
    :filter="filter"
  >
    <template v-slot:filters>
      <v-row
        dense
        justify="center"
      >
        <v-col>
          <AgreementSelect
            v-model="taskAgreementFilter"
            class="pr-1"
            @input="isChanged = true"
          />
        </v-col>
        <v-col>
          <ImplementerSelect
            v-model="taskImplementerFilter"
            :multiple-select="false"
            label="Виконавець"
            placeholder="Введіть iм’я виконавця"
          />
        </v-col>
        <v-col cols="3">
          <EnumSelect
            v-model="taskStatusFilter"
            :items="taskStatuses"
            label="Статус"
            placeholder="Виберіть статус задачі"
            clearable
            :hide-details="true"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as tasksApi from "../../backend/tasksApi.js";
import * as taskTypes from "../../helpers/enums/TaskType.js";
import * as taskStatusesApi from "../../helpers/enums/TaskStatus.js";
import EnumSelect from "@/components/selects/EnumSelect";
import AgreementSelect from "../agreements/AgreementSelect.vue";
import ImplementerSelect from "../employees/EmployeesSelect.vue";

export default {
  components: {
    DataList,
    EnumSelect,
    ImplementerSelect,
    AgreementSelect,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Дата", name: "date" },
      { title: "Угода", name: "agreement" },
      { title: "Створив", name: "creator" },
      { title: "Виконавець", name: "implementer" },
      { title: "Тип", name: "type" },
      { title: "Статус", name: "status" },
      { title: "Дата виконання", name: "planDate" },
    ],
    taskAgreementFilter: null,
    taskImplementerFilter: null,
    taskStatusFilter: null,
  }),
  computed: {
    taskStatuses(){
      const statuses = taskStatusesApi.getStatuses();
      return statuses.map(item => {
        return {
          value: item.value,
          text: item.label,
        };
      });
    },
    filter() {
      return {
        taskStatusFilter: {
          id: this.taskStatusFilter ?? "",
        },
        taskAgreementFilter: {
          id: this.taskAgreementFilter?.id || "",
          title: this.taskAgreementFilter?.title || "",
        },
        taskImplementerFilter: {
          id: this.taskImplementerFilter?.id || "",
          title: this.taskImplementerFilter?.title || "",
        },
      };
    },
    filterParams() {
      return `filter.taskStatus=${this.filter?.taskStatusFilter?.id ?? ""}
              &filter.taskAgreementId=${this.filter?.taskAgreementFilter?.id ?? ""}
              &filter.taskImplementerId=${this.filter?.taskImplementerFilter?.id ?? ""}`;
    },
  },
  methods: {
    async getTasks(...args) {
      const tasks = await tasksApi.getTasks(args[0], args[1], args[2], args[3]);

      tasks.result = tasks.result.map(task=>{
        return {
          id: task.id,
          title: task.title,
          date: task.date,
          creator: task.creator != null ? task.creator.title : "",
          implementer: task.implementer != null ? task.implementer.title : "",
          status: task.status != 0 ? taskStatusesApi.getEnumDescription(task.status) : "",
          type: task.type != 0 ? taskTypes.getEnumDescription(task.type) : "",
          planDate: task.planDate,
          agreement: task.agreement != null ? task.agreement.title : "",
        };
      });

      return tasks;
    },
  },
};
</script>
